module.exports = __webpack_public_path__ + "static/media/up-logo.02b34429.jpg";